/* eslint-disable no-undef */
Sofatutor.Classes.NewVideo = class {
  constructor() {
    this.videoPlayer = document.querySelector('.vjs-tech');
    this.zazieImage = document.querySelector('.videos-header__image');

    this.attachEventListeners();
  }

  attachEventListeners = () => {
    this.videoPlayer.addEventListener('play', () => this.hideZazie());
    this.videoPlayer.addEventListener('pause', () => this.showZazie());
  };

  hideZazie = () => {
    this.zazieImage.classList.add('js-zazie');
  };

  showZazie = () => {
    this.zazieImage.classList.remove('js-zazie');
  };
};

document.addEventListener('turbolinks:load', () => {
  if (document.querySelector('.information-videos-page')) {
    new Sofatutor.Classes.NewVideo();
  }
});
